<template>
  <n-modal class="n-document-modal-do-sign" @close="$emit('close')">
    <h3>Подписать</h3>
    <n-button color="primary" icon="file-signature" wide @click="s_sign">Подписать</n-button>
  </n-modal>
</template>

<script>
import Pki from './../Document/_DocumentModalDoSign/Pki'

export default {
  name: 'CModalJournalDoSign',
  props: [ 'data', ],
  data: () => ({
    websoket: null,
  }),
  created() {
    Pki.start()
    Pki.config({
      onError: (response) => {
        this.$toast.open({
          message: 'NCA Layer: ' + response.message,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        })
      },
    })
  },
  methods: {
    s_sign() {
      const xmlToSign = `
        <document>
          <content>${this.data}</content>
          <files></files>
        </document>`

      // this.submit(xmlToSign); return

      Pki.sign(xmlToSign, (xml) => {
        this.submit(xml)
      })
    },
    submit(xml) {
      this.$emit('submit', xml)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.n-document-modal-do-sign {
  --n-modal-width: 500px;
}
</style>
